var Anhui = "Anhui";
var Beijing = "Pekin";
var Chongqing = "Çongçing";
var Fujian = "Fujian";
var Gansu = "Kansu";
var Guangdong = "Guangdong";
var Guangxi = "Guangşi";
var Guizhou = "Guizhou";
var Hainan = "Hainan";
var Hebei = "Hebei";
var Heilongjiang = "Heilongjiang";
var Henan = "Henan";
var Hubei = "Hubei";
var Hunan = "Hunan";
var Jiangsu = "Jiangsu";
var Jiangxi = "Jiangxi";
var Jilin = "Jilin";
var Liaoning = "Liaoning";
var Ningxia = "Ningşia";
var Qinghai = "Çinghay";
var Shaanxi = "Şensi";
var Shandong = "Şantung";
var Shanghai = "Şanghay";
var Shanxi = "Şansi";
var Sichuan = "Siçuan";
var Tianjin = "Tientsin";
var Tibet = "Tibet";
var Xinjiang = "Sincan";
var Yunnan = "Yunnan";
var Zhejiang = "Zhejiang";
var CNStates = {
	Anhui: Anhui,
	Beijing: Beijing,
	Chongqing: Chongqing,
	Fujian: Fujian,
	Gansu: Gansu,
	Guangdong: Guangdong,
	Guangxi: Guangxi,
	Guizhou: Guizhou,
	Hainan: Hainan,
	Hebei: Hebei,
	Heilongjiang: Heilongjiang,
	Henan: Henan,
	Hubei: Hubei,
	Hunan: Hunan,
	"Inner Mongolia": "İç Moğolistan",
	Jiangsu: Jiangsu,
	Jiangxi: Jiangxi,
	Jilin: Jilin,
	Liaoning: Liaoning,
	Ningxia: Ningxia,
	Qinghai: Qinghai,
	Shaanxi: Shaanxi,
	Shandong: Shandong,
	Shanghai: Shanghai,
	Shanxi: Shanxi,
	Sichuan: Sichuan,
	Tianjin: Tianjin,
	Tibet: Tibet,
	Xinjiang: Xinjiang,
	Yunnan: Yunnan,
	Zhejiang: Zhejiang
};

export { Anhui, Beijing, Chongqing, Fujian, Gansu, Guangdong, Guangxi, Guizhou, Hainan, Hebei, Heilongjiang, Henan, Hubei, Hunan, Jiangsu, Jiangxi, Jilin, Liaoning, Ningxia, Qinghai, Shaanxi, Shandong, Shanghai, Shanxi, Sichuan, Tianjin, Tibet, Xinjiang, Yunnan, Zhejiang, CNStates as default };
